// Utility for validating object variables
export default function isDefined(obj) {
	const keys = Object.keys(obj);
	const undef = keys.filter((key) => (obj[key] === undefined));
	return undef.length === 0;
};
